import React from 'react'
import { useDispatch } from 'react-redux'
import { Grid, Link, Paper, Theme, Typography, useMediaQuery } from '@mui/material'
import { MenuItem } from '../../../screens/App/App'
import * as settingsActions from '../../../store/settings/settings.actions'
import { makeStyles } from '@mui/styles'
import { useHistory } from 'react-router-dom'
import { getAppTheme } from '../../../shared/config/getAppTheme'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

const useStyles = makeStyles((theme: Theme) => ({
  dashboardImage: {
    width: '100%',
    height: 'auto',
  },
}))

const FamilyMember = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const theme: Theme = getAppTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  const handleNavigation = (section: string) => {
    dispatch(settingsActions.setNavPoint([MenuItem.familyMember, section]))
    history.replace(`/${MenuItem.familyMember}/${section}`)
  }

  const linkIconStyle = {
    width: '15px',
    height: '15px',
    color: theme.palette.primary.main,
    marginLeft: '10px',
    marginTop: '-3px',
  }

  const mobileLinkContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0!important',
    cursor: 'pointer',
  }

  const linkStyle = {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  }

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Familienmitglieder</Typography>
      <Typography variant='subtitle1' />
      <Grid container spacing={3}>
        <Grid item xs={downMd ? 12 : 6}>
          <Typography variant='body1'>
            Hier dreht sich alles um unsere gemeinsame Geschichte, die Freude der besonderen Momente und die
            einzigartige Verbundenheit, die uns als Familie auszeichnet. Tauche ein in die Vergangenheit und
            erkunde die Verästelungen unseres Familienstammbaums. Von den Wurzeln bis zu den Zweigen erzählt
            jede Verbindung eine einzigartige Geschichte. Hier findest du die grafische Darstellung unserer
            generationsübergreifenden Bindungen. Feiere mit uns die Freude des Lebens!
            <br />
            Der Geburtstagskalender hält alle wichtigen Termine fest, damit du keinen besonderen Tag in der
            Familie verpasst. Gemeinsam die Glückwünsche teilen und die Momente der Freude feiern.
          </Typography>
        </Grid>
        <Grid item xs={downMd ? 12 : 6}>
          <Typography variant='body1'>
            Mache dich mit den vielen Gesichtern unserer Familie vertraut. Die Familienmitgliederliste
            bietet einen Überblick über die Vielfalt unserer Gemeinschaft. Klicke auf die Namen, um mehr
            über jeden Einzelnen zu erfahren. Entdecke die Welt unserer Familie auf einer interaktiven
            Karte. Finde heraus, wo unsere Familienmitglieder leben und wie weit die Wurzeln unserer
            Familie gereicht haben. Diese Karte zeigt nicht nur geografische Verteilungen, sondern auch die
            Ausdehnung unserer familiären Bande. Wir hoffen, dass diese Seite dazu beiträgt, unsere
            Familiengemeinschaft näher zusammenzubringen und die verschiedenen Aspekte unseres familiären
            Erbes zu schätzen. Viel Freude beim Erkunden!
          </Typography>
        </Grid>

        {!downMd && (
          <>
            <Grid item xs={downSm ? 6 : 3}>
              <Link
                sx={linkStyle}
                underline='hover'
                onClick={() => handleNavigation('tree')}
              >
                <img src='/images/tree.jpg' className={classes.dashboardImage} alt='Stammbaum' />
              </Link>
            </Grid>
            {downSm && (
              <Grid item xs={6} sx={mobileLinkContainerStyle}>
                <Link
                  sx={linkStyle}
                  underline='hover'
                  onClick={() => handleNavigation('tree')}
                >
                  <Typography variant='body1'>Stammbaum</Typography>
                </Link>
              </Grid>
            )}
          </>
        )}

        <Grid item xs={downSm ? 6 : (downMd ? 4 : 3)}>
          <Link
            sx={linkStyle}
            underline='hover'
            onClick={() => handleNavigation('table')}
          >
            <img src='/images/list.jpg' className={classes.dashboardImage} alt='Mitgliederliste' />
          </Link>
        </Grid>

        {downSm && (
          <Grid item xs={6} sx={mobileLinkContainerStyle}>
            <Link
              sx={linkStyle}
              underline='hover'
              onClick={() => handleNavigation('table')}
            >
              <Typography variant='body1' sx={{ color: theme.palette.primary.main }}>
                Mitgliederliste
              </Typography>
              <ArrowForwardIosIcon sx={linkIconStyle} />
            </Link>
          </Grid>
        )}

        <Grid item xs={downSm ? 6 : (downMd ? 4 : 3)}>
          <Link
            sx={linkStyle}
            underline='hover'
            onClick={() => handleNavigation('calendar')}
          >
            <img src='/images/calendar.jpg' className={classes.dashboardImage} alt='Geburtstagskalender' />
          </Link>
        </Grid>

        {downSm && (
          <Grid item xs={6} sx={mobileLinkContainerStyle}>
            <Link
              sx={linkStyle}
              underline='hover'
              onClick={() => handleNavigation('calendar')}
            >
              <Typography variant='body1' sx={{ color: theme.palette.primary.main }}>
                Geburtstagskalender
              </Typography>
              <ArrowForwardIosIcon sx={linkIconStyle} />
            </Link>
          </Grid>
        )}

        <Grid item xs={downSm ? 6 : (downMd ? 4 : 3)}>
          <Link
            sx={linkStyle}
            underline='hover'
            onClick={() => handleNavigation('map')}
          >
            <img src='/images/map.jpg' className={classes.dashboardImage} alt='Karte' />
          </Link>
        </Grid>

        {downSm && (
          <Grid item xs={6} sx={mobileLinkContainerStyle}>
            <Link
              sx={linkStyle}
              underline='hover'
              onClick={() => handleNavigation('map')}
            >
              <Typography variant='body1' sx={{ color: theme.palette.primary.main }}>
                Karte der Wohnorte
              </Typography>
              <ArrowForwardIosIcon sx={linkIconStyle} />
            </Link>
          </Grid>
        )}
      </Grid>
    </Paper>
  )
}

export default FamilyMember
